import { QRCodeSVG } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export const LabelSheet = ({ items, onClose }) => (
  <div className="fixed inset-0 z-50 overflow-auto bg-white p-6" data-testid="label-sheet">
    <div className="mb-5 flex items-center gap-3 no-print">
      <h2 className="font-display text-xl font-bold">Print labels ({items.length})</h2>
      <Button onClick={() => window.print()} data-testid="print-labels-button" className="bg-[#134e4a] hover:bg-[#0f3f3c]">
        <Printer size={15} className="mr-2" /> Print
      </Button>
      <Button variant="outline" onClick={onClose} data-testid="close-labels-button">Close</Button>
    </div>
    <div className="print-sheet grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
      {items.map((s) => (
        <div key={s.id} className="flex items-center gap-3 border border-slate-300 p-3" data-testid={`label-${s.barcode}`}>
          <QRCodeSVG value={s.barcode} size={62} level="M" />
          <div className="min-w-0 leading-tight">
            <div className="font-mono text-xs font-semibold">{s.barcode}</div>
            <div className="truncate text-xs text-slate-600">{s.patient_name}</div>
            <div className="text-xs text-slate-500">
              {s.kind === "slide"
                ? `${s.slide_type || s.stain || "Slide"} · Blk ${s.block_designation || "—"} L${s.level || "—"}`
                : `Block ${s.block_designation || s.label || ""}`} · {s.location_rack}/{s.location_shelf}/{s.location_box}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default LabelSheet;
